module.exports = __webpack_public_path__ + "static/media/tachometer-alt.8c06d0b3.svg";